import React, { useState } from 'react'
import Footer from '../components/Footer'
import Avatar from '../Images/A1.png'
import { FaChevronLeft, FaChevronRight, FaPlus } from 'react-icons/fa6'
import { IoMdTime } from 'react-icons/io'

const About = () => {  
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Incorporated in 2006, Lenpec Global Concept Limited has steadily built a reputation as a reliable procurement partner for oil and gas projects in Nigeria."
    },
    {
      title: "Our operations are driven by strict quality assurance, HSE compliance, and strong relationships with OEMs and trusted manufacturers."
    },
    {
      title: "Today, we support major energy, construction, and infrastructure projects with dependable sourcing and timely delivery."
    }
  ];

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });

  const testimonials = [
    {
      quote: "Lenpec Global Concept Limited has consistently delivered quality materials on schedule. Their professionalism and attention to specification compliance set them apart.",
      author: "Project Engineer",
      position: "Oil & Gas EPC Contractor"
    },
    {
      quote: "Working with Lenpec has simplified our procurement process. Their ability to source directly from OEMs gives us confidence in every delivery.",
      author: "Procurement Manager",
      position: "Energy Services Company"
    },
    {
      quote: "Lenpec’s commitment to safety, quality, and reliability makes them a trusted partner for critical projects.",
      author: "Operations Lead",
      position: "Infrastructure Development Firm"
    }
  ];

  const handlePrevs = () => {
    setCurrentTestimonial((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNexts = () => {
    setCurrentTestimonial((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    console.log('Form submitted:', formData);
    alert('Thank you for contacting Lenpec Global Concept Limited. Our team will respond shortly.');
  };

  return (
    <div>

      <secton className="about_hero">
        <div className="textCarrrier">          
          <div className="mission_left">
            <span className="section_label  wow animate__animated animate__fadeInUp" data-wow-delay="1s">+ Reliable procurement since 2006.</span>

            <h1 className=" wow animate__animated animate__fadeInUp" data-wow-delay="1.5s">About Us</h1>

            <p className=" wow animate__animated animate__fadeInUp" data-wow-delay="1.8s">
              Lenpec Global Concept Limited is a Nigerian-owned procurement and supply company
              serving the oil & gas, construction, and industrial sectors.
            </p>
          </div>
        </div>
        <div className="imgcarrier wow animate__animated animate__fadeInUp" data-wow-delay="1s">
          <img src={Avatar} alt="img" />
        </div>
      </secton>

      <div className="hero-divider"/>

      <div className="about_hero-section">
        <div className="content-wrapper wow animate__animated animate__fadeInUp" data-wow-delay="1s">
          <h1 className="main-heading">
            Trusted procurement solutions<br />
            for energy and infrastructure projects.
          </h1>
          
          <p className="subtitle">
            With over a decade of industry experience, we specialize in sourcing
            pipes, steel products, fittings, flanges, and industrial equipment
            that meet strict project and regulatory requirements.
          </p>
          
          <div className="stats-container">
            <div className="stat-item">
              <div className="stat-number">2006</div>
              <div className="stat-label">Year Incorporated</div>
            </div>
            
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">Nigerian Owned</div>
            </div>
            
            <div className="stat-item">
              <div className="stat-number">Major</div>
              <div className="stat-label">Energy Clients Served</div>
            </div>
          </div>
        </div>
      </div>

      <div className="history-section">
        <div className="container">
          <div className="left-content">
            <div className="section-label wow animate__animated animate__fadeInUp" data-wow-delay="1s">
              <FaPlus className="plus-icon" />
              <span>Our history</span>
            </div>
            
            <h2 className="main-title wow animate__animated animate__fadeInUp" data-wow-delay="1.3s">Our company today</h2>
            
            <p className="description wow animate__animated animate__fadeInUp" data-wow-delay="1.5s">
              Lenpec Global Concept Limited operates with a strong focus on quality,
              safety, and operational excellence, supporting complex procurement
              requirements across the oil and gas value chain.
            </p>
            
            <div className="navigation-buttons wow animate__animated animate__fadeInUp" data-wow-delay="1.8s">
              <button className="nav-btn" onClick={handlePrev} aria-label="Previous">
                <FaChevronLeft />
              </button>
              <button className="nav-btn" onClick={handleNext} aria-label="Next">
                <FaChevronRight />
              </button>
            </div>
          </div>
          
          <div className="right-content wow animate__animated animate__fadeInUp" data-wow-delay="2s">
            <div className="quote-card">
              <div className="icon-wrapper">
                <IoMdTime className="time-icon" />
              </div>
              <p className="quote-text">
                {slides[currentSlide].title}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="testimonial-contact-wrapper">
        <section className="testimonial-section wow animate__animated animate__fadeInUp" data-wow-delay="1s">
          <div className="testimonial-container">
            <div className="section-label">
              <FaPlus className="plus-icon" />
              <span>What our clients say</span>
            </div>
            
            <div className="testimonial-content">
              <blockquote className="testimonial-quote">
                "{testimonials[currentTestimonial].quote}"
              </blockquote>
              
              <div className="author-info">
                <p className="author-name">{testimonials[currentTestimonial].author}</p>
                <p className="author-position">{testimonials[currentTestimonial].position}</p>
              </div>
            </div>
            
            <div className="testimonial-navigation">
              <button className="nav-btn" onClick={handlePrevs} aria-label="Previous testimonial">
                <FaChevronLeft />
              </button>
              <button className="nav-btn" onClick={handleNexts} aria-label="Next testimonial">
                <FaChevronRight />
              </button>
            </div>
          </div>
        </section>

        <section className="contact-section">
          <div className="contact-container">
            <div className="section-label wow animate__animated animate__fadeInUp" data-wow-delay="1s">
              <FaPlus className="plus-icon" />
              <span>Contact us</span>
            </div>
            
            <div className="contact-form">
              <h2 className="contact-title">Let’s work together.</h2>
              
              <p className="contact-description">
                Send us your project specifications and procurement requirements.
                Our team is ready to support your next project.
              </p>

              <div className="form-row">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First name*"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  className="form-input"
                />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last name*"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  className="form-input"
                />
              </div>
              
              <div className="form-row">
                <input
                  type="email"
                  name="email"
                  placeholder="Email*"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="form-input"
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone*"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="form-input"
                />
              </div>
              
              <textarea
                name="message"
                placeholder="Project details / specifications*"
                value={formData.message}
                onChange={handleInputChange}
                className="form-textarea"
                rows="5"
              />
              
              <button onClick={handleSubmit} className="submit-btn">
                Submit
              </button>
              <div className="contact-margin"/>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  )
}

export default About
